import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TransactionService {
    private selectedTransactionSubject = new BehaviorSubject<any>(null);
    selectedTransaction$ = this.selectedTransactionSubject.asObservable();

    constructor() {}

    setSelectedTransaction(selectedTrans: any) {
        this.selectedTransactionSubject.next(selectedTrans);
    }
}
